export default {
    'order.title.statistic.ordertotalamount': 'Order total amount',
    'order.title.statistic.ordertotalnumber': 'Order total number',
    'order.title.statistic.ordertotalfee': 'Order total service fee',
    'order.title.statistic.mix': 'Mix',
    'order.export.type.orderin': 'Orderin',
    'order.export.type.orderout': 'Orderout',
    'order.export.type.assetlog': 'Asset log',
    'order.nameLabel.id': 'ID',
    'order.nameLabel.orderno': 'Order No',
    'order.nameLabel.merchantorderno': 'Mer Order No',
    'order.nameLabel.merchantno': 'Merchant No',
    'order.nameLabel.username': 'User name',
    'order.nameLabel.nickname': 'Nick name',
    'order.nameLabel.currency': 'Currency',
    'order.nameLabel.status': 'Status',
    'order.nameLabel.amount': 'Amount',
    'order.nameLabel.realamount': 'Real amount',
    'order.nameLabel.servicefee': 'Service fee',
    'order.nameLabel.updatetime': 'Updatetime',
    'order.nameLabel.orderstatus': 'Order status',
    'order.nameLabel.date': 'Order date',
    'order.nameLabel.datetime': 'Datetime',
    'order.nameLabel.datefrom': 'Date from',
    'order.nameLabel.dateto': 'Date to',
    'order.nameLabel.type': 'Type',
    'order.nameLabel.cpf': 'CPF No',
    'order.nameLabel.account': 'Account',
    'order.nameLabel.name': 'Name',
    'order.nameLabel.email': 'Email',
    'order.nameLabel.phone': 'Phone',
    'order.nameLabel.oldamount': 'Old amount',
    'order.nameLabel.newamount': 'New amount',
    'order.nameLabel.oldamountfrozen': 'Old frozen amount',
    'order.nameLabel.newamountfrozen': 'New frozen amount',
    'order.nameLabel.changeamount': 'Change amount',
    'order.nameLabel.businesscode': 'Business code',
    'order.nameLabel.customeraccount': 'Customer account',
    'order.nameLabel.customername': 'Customer name',
    'order.nameLabel.customeremail': 'Customer email',
    'order.nameLabel.customerphone': 'Customer phone',
    'order.nameLabel.signtype': 'Sign type',
    'order.asset.type1': 'Orderin',
    'order.asset.type2': 'Orderout',
    'order.asset.type3': 'Frozen',
    'order.asset.type4': 'Unfrozen',
    'order.asset.type5': 'Orderin redo',
    'order.asset.type6': 'Orderout redo',
    'order.asset.type7': 'Cash USDT',
    'order.asset.type8': 'Amount change',
    'order.status.success': 'Success',
    'order.status.pending': 'Pending',
    'order.status.close': 'Closed',
    'order.status.failed': 'failed',
    'order.status.wait': 'Waiting',
    'order.status.complete': 'Completed',
    'order.button.export': 'Export',
    'order.button.statistic': 'Statistic',
};
